import React, { ReactElement } from 'react';
import TextBlock from '../text-block/text-block.component';
import useStylesIconOffsetBlock from './icon-offset-block.styles';

const IconOffsetBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    offsetTop,
    offsetLeft,
    children,
  } = props;

  const stylesProps: MaterialUIStylesProps = {
    offsetTop,
    offsetLeft,
  };

  const { classes } = useStylesIconOffsetBlock(stylesProps);

  return (
    <TextBlock className={classes.iconOffsetBlock}>
      {children}
    </TextBlock>
  );
});

export default IconOffsetBlock;
